const VERSION_SUFFIX = /\s*[-(\[]\s*(instrumental|remix|acoustic|live|edit|version|mix|radio edit|extended|slowed|sped up|remastered|demo|pt\.?\s*\d+|part\s*\d+)[^)\]]*[)\]]?\s*$/i;

export function normalizeTrackTitle(title: string | undefined | null): string {
  if (!title) return "";
  return title
    .toLowerCase()
    .replace(/\(feat\.?[^)]*\)|\[feat\.?[^\]]*\]|\bfeat\.?\s+[^-()]+/gi, " ")
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function trackIdentityKey(title: string | undefined | null): string {
  const raw = (title || "").trim();
  const versionMatch = raw.match(VERSION_SUFFIX);
  const version = versionMatch ? normalizeTrackTitle(versionMatch[0]) : "";
  const base = normalizeTrackTitle(versionMatch ? raw.slice(0, versionMatch.index) : raw);
  return version ? `${base}|${version}` : base;
}
